import CommonLink from 'components_v2/CommonLink'
import React from 'react'
const getFirst25Words = (text = '') => text.split(' ').slice(0, 25).join(' ')

export const CoachTileGrid = ({ coach }) => (
  <div className='coach ng-scope' ng-repeat='coach in coaches'>
    <div className='coach-tile ng-isolate-scope' coach='coach'>
      <CommonLink to={`/instructors/${coach.slug}`}>
        <div className='coach-photo'>
          <img
            alt={coach.user?.name}
            className='profile-photo-image img-circle ng-scope lazy-loaded'
            src={coach.user?.profilePhoto?.url}
          />
        </div>
        <div className='coach-name ng-binding'>{coach.user.name}</div>
      </CommonLink>
    </div>
  </div>
)

export const CoachTileList = ({ coach, index }) => (
  <div className='coach ng-scope'>
    <div className='coach-card ng-isolate-scope'>
      <CommonLink
        className='coach-cover-container'
        to={`/instructors/${coach.slug}?ref=coaches_bb_ch_list_${index}`}
      >
        <div className='coach-cover'>
          <img
            alt={coach.user?.name}
            className='ng-scope lazy-loaded'
            src={coach.coverPhoto?.url}
          />
        </div>
      </CommonLink>
      <CommonLink
        to={`/instructors/${coach.slug}`}
        className='coach-top-section'
      >
        <div className='profile-photo'>
          <img
            className='profile-photo-image img-circle'
            src={coach.user?.profilePhoto?.url}
            alt={coach.user?.name}
          />
        </div>
        <div
          className='profile-name ng-binding'
          href='http://localhost:3000/instructors/deepika'
        >
          {coach.user?.name}
        </div>
      </CommonLink>
      <div className='coach-content card-content'>
        <div className='coach-bio bio'>
          <span className='ng-binding'>
            {coach.tagLine || getFirst25Words(coach.bio)}
          </span>
        </div>
      </div>
    </div>
  </div>
)
